<template>
    <!-- eslint-disable -->
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24" height="16" viewBox="0 0 24 16">
    <defs>
        <clipPath id="clip-Top">
        <rect width="24" height="16"/>
        </clipPath>
    </defs>
    <g id="Top" clip-path="url(#clip-Top)">
        <g id="noun_Arrow_1787131" transform="translate(18.3 4.81) rotate(90)">
        <g id="Groupe_3068" data-name="Groupe 3068" transform="translate(0 13.492) rotate(-90)">
            <path id="Tracé_3220" data-name="Tracé 3220" d="M6.789,6.744a.613.613,0,0,0,.369-.153l6.13-5.517a.616.616,0,0,0-.824-.915L6.746,5.307,1.027.158A.616.616,0,0,0,.2,1.073L6.334,6.59a.614.614,0,0,0,.455.153Z" transform="translate(0 0)" :fill="color" :stroke="color" stroke-width="0.5"/>
        </g>
        </g>
    </g>
    </svg>
</template>
<script>
import { Colorable } from '../../mixins';

export default {
    name: 'ChevronDown',
    mixins: [Colorable],
};
</script>
